export default __webpack_public_path__ + "static/media/outlook-2016.709e0224.svg";